import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "residents" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "ml-auto d-flex align-items-center"
}
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "apartment-list-and-details" }
const _hoisted_9 = { class: "fs-18 text-gray text-uppercase mx-4 mt-4 mb-3" }
const _hoisted_10 = { class: "residents__tabs" }
const _hoisted_11 = {
  key: 0,
  class: "apartment-details-tab__loader"
}
const _hoisted_12 = {
  key: 1,
  class: "residents mt-3"
}
const _hoisted_13 = { class: "residents__tabs mt-3" }
const _hoisted_14 = { class: "p-tabview-title" }
const _hoisted_15 = { class: "p-tabview-title" }
const _hoisted_16 = { class: "p-tabview-title" }
const _hoisted_17 = { class: "p-tabview-title" }
const _hoisted_18 = { class: "d-flex align-items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DialogImportFile = _resolveComponent("DialogImportFile")
  const _component_BuildingSelector = _resolveComponent("BuildingSelector")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_EntrancePlantApartment = _resolveComponent("EntrancePlantApartment")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_ContactSection = _resolveComponent("ContactSection")
  const _component_GateAccessSection = _resolveComponent("GateAccessSection")
  const _component_BadgesSection = _resolveComponent("BadgesSection")
  const _component_CodeSection = _resolveComponent("CodeSection")
  const _component_DialogMassiveInviteResidents = _resolveComponent("DialogMassiveInviteResidents")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            onClick: _withModifiers(_ctx.handleClick, ["prevent"]),
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.backToText), 1)
            ]),
            _: 1
          }, 8, ["to", "onClick"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.Residents")), 1)
        ]),
        (!_ctx.isBRFA)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_ElDropdown, {
                trigger: "click",
                placement: "bottom-end",
                "popper-class": "el-dropdown__popper el-dropdown--context"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.triggerFilePicker }, {
                        default: _withCtx(() => [
                          _createVNode("input", {
                            type: "file",
                            id: "fileInput",
                            style: {"display":"none"},
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                            accept: ".csv"
                          }, null, 32),
                          _createVNode("span", null, _toDisplayString(_ctx.$t("general.import")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.onExportClick }, {
                        default: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t("general.export")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ElDropdownItem, {
                        disabled: !_ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                        onClick: _ctx.toggleMassiveInvitation
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t(
                                            "AppResourceEP.InviteResidentsMassively"
                                        )), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Button, { class: "p-button-text p-button-icon text-gray p-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                            ,
                        "aria-label": "icon-ellipsis-v"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_DialogImportFile, {
        EntrancePlantDetail: _ctx.currentEntrancePlant,
        importedData: _ctx.importedData,
        isVisible: _ctx.isVisibleDialogImportFile,
        onHideDialog: _ctx.handleCloseDialog,
        onOverwrite: _ctx.overwrite,
        isCallingMode: _ctx.isCallingCode
      }, null, 8, ["EntrancePlantDetail", "importedData", "isVisible", "onHideDialog", "onOverwrite", "isCallingMode"])
    ]),
    (_ctx.isBRFA && _ctx.step === 0)
      ? (_openBlock(), _createBlock(_component_BuildingSelector, {
          key: 0,
          onBuildingSelected: _ctx.selectBuilding
        }, null, 8, ["onBuildingSelected"]))
      : _createCommentVNode("", true),
    (!_ctx.isBRFA || (_ctx.isBRFA && _ctx.step === 1))
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_TabView, {
            class: "buildings-tabs p-tabview--custom",
            onTabChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTabClick($event)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabOptions, (tabOption, index) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: index,
                  header: tabOption.name
                }, null, 8, ["header"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ElScrollbar, { class: "apartment-list mt-2" }, {
              default: _withCtx(() => [
                (_ctx.isBRFA)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.buildingStructure[_ctx.tabSelectedIndex].floors, (floorsection, floorIndex) => {
                      return (_openBlock(), _createBlock("div", { key: floorIndex }, [
                        _createVNode("h1", _hoisted_9, _toDisplayString(floorsection.floor.name), 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, apartmentIndex) => {
                          return (_openBlock(), _createBlock(_component_EntrancePlantApartment, {
                            class: ["mx-4 my-2", {
                                'selected-apartment':
                                    !!_ctx.apartmentSelected &&
                                    _ctx.apartmentSelected.apartmentId ===
                                        apartment.apartmentId,
                            }],
                            onApartmentSelected: ($event: any) => (_ctx.showApartmentDetail(apartment)),
                            apartment: apartment,
                            key: apartmentIndex,
                            callingCodeOrBrfa: _ctx.isBRFA
                          }, null, 8, ["class", "onApartmentSelected", "apartment", "callingCodeOrBrfa"]))
                        }), 128))
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (!_ctx.isBRFA)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.apartments, (apartment) => {
                      return (_openBlock(), _createBlock(_component_EntrancePlantApartment, {
                        class: ["mx-4 my-2", {
                            'selected-apartment':
                                !!_ctx.apartmentSelected &&
                                _ctx.apartmentSelected.apartmentId ===
                                    apartment.apartmentId,
                        }],
                        onApartmentSelected: ($event: any) => (_ctx.showApartmentDetail(apartment)),
                        apartment: apartment,
                        key: apartment.apartmentId,
                        callingCodeOrBrfa: _ctx.isCallingCode
                      }, null, 8, ["class", "onApartmentSelected", "apartment", "callingCodeOrBrfa"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_10, [
              (_ctx.changingApartment)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode(_component_ProgressSpinner)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.apartmentSelected && !_ctx.changingApartment)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("h4", null, _toDisplayString(_ctx.apartmentSelected.name), 1),
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_TabView, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_TabPanel, null, {
                            header: _withCtx(() => [
                              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("AppResourceEP.ContactTab")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ContactSection, {
                                    key: _ctx.apartmentSelected.apartmentId,
                                    apartment: _ctx.apartmentSelected,
                                    onOnAddEditLabel: _ctx.onAddEditLabel,
                                    onOnDeleteLabel: _ctx.onDeleteLabel,
                                    onUpdateList: _ctx.handleUpdateList
                                  }, null, 8, ["apartment", "onOnAddEditLabel", "onOnDeleteLabel", "onUpdateList"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_TabPanel, null, {
                            header: _withCtx(() => [
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.GateAccessTab")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_GateAccessSection, {
                                    key: _ctx.apartmentSelected.apartmentId,
                                    apartment: _ctx.apartmentSelected,
                                    onOnNewGates: _ctx.onNewGatesEvent
                                  }, null, 8, ["apartment", "onOnNewGates"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_TabPanel, null, {
                            header: _withCtx(() => [
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.BadgeTab")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_BadgesSection, {
                                key: _ctx.apartmentSelected.apartmentId,
                                apartment: _ctx.apartmentSelected,
                                onOnBadgesChange: _ctx.onBadgesChangeEvent
                              }, null, 8, ["apartment", "onOnBadgesChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_TabPanel, null, {
                            header: _withCtx(() => [
                              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("AppResourceEP.CodeTab")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_CodeSection, {
                                key: _ctx.apartmentSelected.apartmentId,
                                apartment: _ctx.apartmentSelected,
                                onOnNewCodeEvent: _ctx.onNewCodeEvent,
                                onOnShareEmailEvent: _ctx.onShareEmail
                              }, null, 8, ["apartment", "onOnNewCodeEvent", "onOnShareEmailEvent"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_Button, {
                        class: "ml-auto p-button-rounded p-button-raised p-button--m",
                        onClick: _ctx.onSaveClick,
                        disabled: 
                                !_ctx.currentEntrancePlant.syncStatus
                                    ?.canEditWithPropagation
                            
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("SaveChanges")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DialogMassiveInviteResidents, {
      isVisible: _ctx.isVisibleMassiveInvite,
      onHideDialog: _ctx.toggleMassiveInvitation,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "onHideDialog", "onUpdateList"])
  ], 64))
}